import { ItemList, WithContext } from 'schema-dts';

import { DEFAULT_STRUCTURE } from '../constants';

export type ItemListingMapperResult = ReturnType<typeof itemListingMapper>;

export type ItemListingElement = {
  name?: string;
  item: string;
  position: number;
};

export type ItemListingParams = {
  name?: string;
  items: ItemListingElement[];
};

export const createListItem = (params: ItemListingElement) => ({
  '@type': 'ListItem' as const,
  ...params,
});

export const itemListingMapper = (
  data: ItemListingParams
): WithContext<ItemList> => ({
  ...DEFAULT_STRUCTURE,
  '@type': 'ItemList' as const,
  name: data.name || '',
  itemListElement: data.items.map((item, index) =>
    createListItem({ ...item, position: index + 1 })
  ),
});
